/**
 * NotFoundPage — T21.
 *
 * Rendered for any route that doesn't match a known path.
 */
import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <Center h="100vh" data-testid="not-found-page">
      <Stack align="center" gap="md">
        <Title order={1}>404</Title>
        <Text c="dimmed">This page does not exist.</Text>
        <Button component={Link} to="/" variant="light" data-testid="go-home-btn">
          Go home
        </Button>
      </Stack>
    </Center>
  );
}
